import { Component, OnInit, Input, Output, EventEmitter, Injector } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { ModalSize } from 'src/modules/base/services/smart-modal.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { SmartModalService } from 'src/modules/base/services/smart-modal.service';
import { ImageUploadPopupComponent } from 'src/modules/kx-shared/components/image-upload-popup/image-upload-popup.component';
import { PopupFormComponent } from 'src/modules/base/components/popupform/popupform.component';

@Component({
    selector: 'app-doctor-card',
    templateUrl: './doctor-card.component.html',
    styleUrls: ['./doctor-card.component.scss'],
    standalone: false
})
export class DoctorCardComponent implements OnInit {
  @Input() dataForCard: Array<any>;
  cardData: any;
  docData: any;
  imageURL = ' ';
  data: any;
  selectedFiles: Array<any> = [];
  imageSrc: any;
  file: FileList;
  file_id: string;
  uploadImage: boolean = false;
  documentId: any;
  id: string;
  resource: any;
  action: any;

  constructor(
    public injector: Injector,
    public router: Router,
    private alerts: AlertsService,
    public route: ActivatedRoute,
    private baseService: BaseService,
    private smartModalService: SmartModalService
  ) { }

  ngOnInit() {
    console.log("Data For Card is ", this.dataForCard);
    var data = this.dataForCard[0];
    if (this.dataForCard != undefined && this.dataForCard) {
      this.file_id = data.profile_id;
      this.id = data.id;
      this.action = this.route.snapshot.data.action;
      this.resource = this.route.snapshot.data.resource;
    }
    this.dataForCard[0]['practitioner_id'] = this.dataForCard[0].id;
  }

  ngAfterViewInit() {
    if (this.file_id != null) {
      let file_id = this.file_id;
      this.getProfileData(file_id);
    }
  }

  getProfileData(file_id?) {
    this.selectedFiles = [];
    this.file_id = file_id;                                                                                                                 
    let documentResource = 'userImage' + '/image-byte-array';
    this.baseService.get(file_id, "", documentResource, 'dms').subscribe(
      (data: any) => {
        this.docData = data.imageData;
        let contentType = 'data:' + data.contentType + ';base64, ';
        let imagebase64 = contentType + data.imageData;
        this.imageURL = imagebase64;
        const fileVal = {
          imageSrc: imagebase64,
          file: {
            name: data.documentName,
            size: data.size,
            contentType: data.contentType
          }
        };
        this.selectedFiles.push(fileVal);
        //console.log("Profile Data",this.selectedFiles);
      }
    );
  }
  showImage(file: any) {
    if ((file.file.type != null && file.file.type.startsWith("image/")) || (file.file.contentType != null && file.file.contentType.startsWith("image/")))
      return true;
    else return false;
  }

  // For image upload Popup
  showUserImageUpload() {
    var data = { "id": this.id, "resource": this.resource }
    this.smartModalService.open(ImageUploadPopupComponent, data, "Upload Image", ModalSize.Md).subscribe(data => {
      if (data) {
        this.getProfileData(data.result);
      }
    }, err => {
      console.log("error occur");
    })
  }

  showDoctorData() {
    let object = {
      "data": this.dataForCard[0],
      "layout_type": "simple",
      "resource": "practitioner_doctor_update",
      "action": "MODIFY"
    }
    this.smartModalService.open(PopupFormComponent, object, "Update Doctor/Care Professional Details", ModalSize.Xl).subscribe(
      res => {
        // object = result.result.resource[0];
        // this.baseService.action(object, "UPDATE_BASIC_DETAILS", "patient-registration", "patient").subscribe(
        //   res => {
            if (res.result.errCode == 0) {
              let currentUrl = this.router.url;
              this.router.navigate([this.route.snapshot.queryParams.returnUrl], { skipLocationChange: true }).then(() => {
                this.router.navigateByUrl(currentUrl);
              });
            }
            else if (res.result.errCode == -1) {
              this.alerts.error(res.result.message);
            }
          // })
      },
      err => {
      })
  }
}
